// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchButton_search__f4tPu","button":"SearchButton_button__bk_vk"};